// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"Content_content_wrapper__2ulXl","loading":"Content_loading__1PRaB"};